import { render, staticRenderFns } from "./OverlayLoading.vue?vue&type=template&id=27df690e"
import script from "./OverlayLoading.vue?vue&type=script&lang=ts"
export * from "./OverlayLoading.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports